<template>
    <text class="e-svg-text-wrap">
        <tspan x="0" :dy="getLineHeight(index)" v-for="(line, index) in lines" :key="`t-${index}`">
            {{ line }}
        </tspan>
        <slot></slot>
    </text>
</template>
<script>
export default {
    name: `e-svg-text-wrap`,
    inheritAttrs: true,
    props: {
        text: {type: String},
        wrapLength: {type: Number, default: 15},
        bottomToTop: {type: Boolean},
        lineHeight: {type: [Number, String], default: 1.3}
    },
    computed: {
        lines() {
            if (!this.text) {
                return null;
            } else if (this.text.length <= this.wrapLength) {
                return [this.text];
            } else {
                const words = this.text.split(` `);
                let lines = [];
                let length = 0;
                let index = 0;
                for (let word of words) {
                    if (lines.length > 0 && (length + word.length <= this.wrapLength ||
                        // Small tolerance to avoid line return for just one word
                        (length + word.length <= this.wrapLength + 5 && index === words.length - 1))) {
                        lines[lines.length - 1] += ` ${word}`;
                        length += word.length;
                    } else {
                        lines.push(word);
                        length = word.length;
                    }
                    index++;
                }
                if (this.bottomToTop) {
                    lines.reverse();
                }
                return lines;
            }
        }
    },
    methods: {
        getLineHeight(index) {
            if (index === 0)
                return 0;
            return (this.bottomToTop ? -1 : 1) * parseFloat(this.lineHeight) + `em`;
        }
    }
}
</script>

<style scoped lang="scss">
.e-svg-text-wrap {
}
</style>
